import request from "../../Utils/curl"
import Utility from "../../Utils/utility"

let wrkSubAgents = {
  /**
   * wrkSubAgent List
   */
  async wrkSubAgentList (context, whereFilter = null) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      if (whereFilter) {
        postData.append("filter", JSON.stringify(whereFilter))
      }

      return await request.curl(context, "wrk_sub_agent_list", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at wrkSubAgentList() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * wrkSubAgent View
   */
  async wrkSubAgentView (context, wrkSubAgentId) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      postData.append("wsa_id", wrkSubAgentId)

      return await request.curl(context, "wrk_sub_agent_view", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at wrkSubAgentView() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * wrkSubAgent Add
   */
  async wrkSubAgentAdd (context, wrkSubAgentObj) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      for (let key in wrkSubAgentObj) {
        postData.append(key, wrkSubAgentObj[key])
      }

      return await request.curl(context, "wrk_sub_agent_add", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at wrkSubAgentAdd() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * wrkSubAgent Edit
   */
  async wrkSubAgentEdit (context, wrkSubAgentObj) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      for (let key in wrkSubAgentObj) {
        postData.append(key, wrkSubAgentObj[key])
      }

      return await request.curl(context, "wrk_sub_agent_edit", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at wrkSubAgentEdit() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * wrkSubAgent Delete
   */
  async wrkSubAgentDelete (context, wrkSubAgentId) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      postData.append("wsa_id", wrkSubAgentId)

      return await request.curl(context, "wrk_sub_agent_delete", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.log("Exception occurred at wrkSubAgentDelete() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * wrkSubAgent FilterList
   */
  async wrkSubAgentFilterList (context, filterName = "") {
    try {
      if (!filterName) {
        return
      }

      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      postData.append("filter_name", filterName)

      return await request.curl(context, "wrk_sub_agent_filter_list", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at wrk_sub_agent_filter_list() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  }
}

export {
  wrkSubAgents
}
